import React from "react";
import logo from "../../assets/images/ascasSVG.svg";
import contact from "../../assets/images/contact.png"
import "./headers.scss";
const Headers = () => {
  let date = new Date();
  let todayDate = `${date.getDate()}-${
    date.getMonth() + 1
  }-${date.getFullYear()}`;
  return (
    <div className="mainHeader">
      <div className="HeaderContainer">
        <div >
          <div className="nameContainer">
            <p>Dr. AISHWARYA PARTHASARATHY</p>
          </div>
          <div className="degreeContainer">
            <div>
              <p>MD(OG) - (AIIMS, New Delhi)., DNB (OG).,</p>
              <p>FNB (Reproductive Medicine)., MRCOG(UK)</p>
              <p>Consultant Gynecologist, Fertility Specialist & Laparoscopic Surgeon</p>
              {/* <p>Prashanth Fertility Center</p> */}
              {/* <p>Visiting Consultant At Various Leading Hospitals</p> */}
            </div>
          </div>
        </div>
        <div className="imgContainer">
          <img src={logo} alt="" />
        </div>
        {/* <div className="contactContainer">
          <img src={contact} alt="" />
          <p>For Booking Appointment</p>
          <span>
            +91 9342521779 <br />
            044 4793 9484
          </span>
        </div> */}
      </div>
      <div style={{ textAlign: "right" }}>
        <section>
          <label style={{ fontSize: "14px", fontWeight: "600" }}>Visit Date :</label>
          <span> {todayDate}</span>
        </section>
      </div>
    </div>
  );
};

export default Headers;
